import { NOT_FOUND } from 'redux-first-router';

const components = {
  HOME: 'Home',
  WORKS: 'Works',
  AGENCY: 'Agency',
  REELS: 'Reels',
  [NOT_FOUND]: 'NotFound',
};

export default (state = 'HOME', action = {}) =>
  components[action.type] || state;



// WEBPACK FOOTER //
// ./src/reducers/page.js